import React, { useState } from 'react';

function GoalForm({ onSubmit }) {
  const [goal, setGoal] = useState({
    title: '',
    grounded: '',
    results: '',
    inFocus: '',
    nextLevel: '',
    deadline: ''
  });

  const handleChange = (e) => {
    setGoal({ ...goal, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(goal);
    setGoal({
      title: '',
      grounded: '',
      results: '',
      inFocus: '',
      nextLevel: '',
      deadline: ''
    });
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #444',
    backgroundColor: '#222',
    color: '#fff',
    fontSize: '1rem',
    marginTop: '6px',
    marginBottom: '16px',
    boxSizing: 'border-box',
  };

  const labelStyle = {
    color: '#FFD700',
    fontFamily: 'Bangers, sans-serif',
    fontSize: '1.1rem',
    letterSpacing: '1px',
    display: 'block',
  };

  const descStyle = {
    color: '#aaa',
    fontSize: '0.9rem',
    marginBottom: '4px',
    display: 'block',
  };

  return (
    <div>
      <h2 style={{
        fontFamily: 'Bangers, sans-serif',
        fontSize: 'clamp(1.5rem, 4vw, 2rem)',
        letterSpacing: '2px',
        color: '#fff',
        marginBottom: '24px',
        textAlign: 'center',
      }}>
        📌 Create a New GRIND Goal
      </h2>

      <form onSubmit={handleSubmit}>
        <label style={labelStyle}>Goal Title</label>
        <input
          type="text"
          name="title"
          value={goal.title}
          onChange={handleChange}
          placeholder="What is your goal?"
          required
          style={inputStyle}
        />

        <label style={labelStyle}>G — Grounded</label>
        <span style={descStyle}>Why is this important to you?</span>
        <textarea
          name="grounded"
          value={goal.grounded}
          onChange={handleChange}
          placeholder="What drives you toward this goal?"
          required
          rows="3"
          style={{ ...inputStyle }}
        />

        <label style={labelStyle}>R — Results-Driven</label>
        <span style={descStyle}>What does success look like?</span>
        <textarea
          name="results"
          value={goal.results}
          onChange={handleChange}
          placeholder="How will you know when you've achieved it?"
          required
          rows="3"
          style={{ ...inputStyle }}
        />

        <label style={labelStyle}>I — In Focus</label>
        <span style={descStyle}>What exactly will you do?</span>
        <textarea
          name="inFocus"
          value={goal.inFocus}
          onChange={handleChange}
          placeholder="Be specific about your actions"
          required
          rows="3"
          style={{ ...inputStyle }}
        />

        <label style={labelStyle}>N — Next-Level</label>
        <span style={descStyle}>How will this challenge you?</span>
        <textarea
          name="nextLevel"
          value={goal.nextLevel}
          onChange={handleChange}
          placeholder="How does this push you beyond your comfort zone?"
          required
          rows="3"
          style={{ ...inputStyle }}
        />

        <label style={labelStyle}>D — Deadline-Focused</label>
        <span style={descStyle}>When will you accomplish this by?</span>
        <input
          type="date"
          name="deadline"
          value={goal.deadline}
          onChange={handleChange}
          required
          style={{ ...inputStyle, colorScheme: 'dark' }}
        />

        <button
          type="submit"
          style={{
            width: '100%',
            padding: '16px',
            backgroundColor: '#FFD700',
            color: '#000',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1.2rem',
            fontFamily: 'Bangers, sans-serif',
            letterSpacing: '2px',
            cursor: 'pointer',
            marginTop: '8px',
          }}
        >
          ➕ Add Goal
        </button>
      </form>

      <p style={{
        textAlign: 'center',
        color: '#888',
        fontStyle: 'italic',
        marginTop: '20px',
        fontSize: '0.95rem',
      }}>
        "Greatness comes from hard work. Stay on the GRIND!"
      </p>
    </div>
  );
}

export default GoalForm;